module.exports = __webpack_public_path__ + "static/media/SourceSansPro-BoldIt.a6f4b945.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-BoldIt.ttf
// module id = 354
// module chunks = 3